import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";

export const useIsSuccessQueryParam = (): [boolean, boolean] => {
  const queryParams = useLocation().search;
  const history = useHistory();
  const [isSuccess, setIsSuccess] = useState(false);
  const [isSuccessQueryInUrl, setIsSuccessQueryInUrl] = useState(false);

  useEffect(() => {
    const success = new URLSearchParams(queryParams).get("isSuccess");
    setIsSuccessQueryInUrl(!!success);
    setIsSuccess(success === "true");
    // This will remove the isSuccess parameter from the url without refreshing the page.
    history.replace(history.location.pathname);
  }, [queryParams, history]);

  return [isSuccessQueryInUrl, isSuccess];
};
